/**
 * Every orientation the scoring screen's sheets and menus run in: portrait,
 * as the whole phone app does (Info.plist, AndroidManifest.xml). Each of its
 * `Modal`s says so, rather than leaving it to the platform's default.
 */
export const MODAL_ORIENTATIONS: Array<'portrait'> = ['portrait']
